import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { apiFetch } from '@/api/client'
import { ApiError } from '@/api/client'
import { LangSwitcher } from '@/components/ui/LangSwitcher'

export function ForgotPasswordPage() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!email.trim()) return
    setError('')
    setLoading(true)
    try {
      await apiFetch('/forgot-password', { method: 'POST', body: JSON.stringify({ email: email.trim() }) })
      setSent(true)
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t('common.error'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="absolute top-4 right-4"><LangSwitcher /></div>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-5xl mb-4">🔑</div>
          <h1 className="text-2xl font-black text-white mb-2">{t('forgotPassword.title')}</h1>
        </div>
        <div className="card-glow p-8">
          {sent ? (
            <div className="text-center">
              <div className="text-4xl mb-4">📬</div>
              <h2 className="text-lg font-bold text-white mb-2">{t('forgotPassword.sentTitle')}</h2>
              <p className="text-sm text-white/50 mb-4">{t('forgotPassword.sentDesc')}</p>
              <a href="/join" className="btn-secondary btn-sm">{t('forgotPassword.backToSignIn')}</a>
            </div>
          ) : (
            <>
              <h2 className="text-lg font-bold text-white mb-1">{t('forgotPassword.heading')}</h2>
              <p className="text-sm text-white/50 mb-6">{t('forgotPassword.desc')}</p>
              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div>
                  <label className="text-sm text-white/70 mb-1.5 block">{t('forgotPassword.emailLabel')}</label>
                  <input className={`input ${error ? 'border-red-500/50' : ''}`} type="email"
                    placeholder={t('join.emailPlaceholder')} value={email}
                    onChange={e => { setEmail(e.target.value); setError('') }} autoFocus required />
                  {error && <p className="text-xs text-red-400 mt-1.5">{error}</p>}
                </div>
                <button type="submit" disabled={loading || !email.trim()} className="btn-primary">
                  {t('forgotPassword.send')}
                </button>
              </form>
              <div className="mt-4 pt-4 border-t border-white/10 text-center">
                <a href="/join" className="text-xs text-white/40 hover:text-white/60 transition-colors">
                  {t('forgotPassword.backToSignIn')}
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
